<template>
  <div class="relative px-4 pt-16 pb-20 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8">
    <div class="relative mx-auto max-w-7xl">
      <h2
        class="
          text-2xl
          font-bold
          leading-9
          tracking-tight
          text-center
          tmsk-blue-text
        "
      >
        Processing Payment
      </h2>
      <div class="grid max-w-lg gap-4 mx-auto mt-12">
        <div class="flex flex-row items-center justify-center">
          <img class="w-24" :src="getAssets(method.imageUrl)" />
        </div>
        <div class="flex flex-row items-center justify-center mt-10">
          <div class="w-20 h-20 border-4 border-teal-100 rounded-full loader" />
        </div>
        <p class="mt-4 text-center tmsk-blue-text">
          Please do not close this page as we process your payment
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import beepAPI from '@/mixins/beepAPI'
import { mapActions } from 'vuex'
export default {
  name: 'PaylahOnTile',
  components: {},
  mixins: [beepAPI],
  props: {
    uuid: {
      type: String,
      required: true
    },
    method: {
      type: Object,
      required: true
    },
    expiryTimestamp: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      hasTimeout: false
    }
  },
  computed: {},
  watch: {},

  // Lifecycle Hooks
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {
    this.commencePolling()
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    ...mapActions(['updateSuccessfulPurchase']),

    commencePolling () {
      const body = {
        uuid: this.uuid,
        expiryTimestamp: this.expiryTimestamp
      }

      this.getPaymentStatus(body)
        .then(
          async response => {
            const { status } = response
            if (status === 'success') {
              await this.updateSuccessfulPurchase(response)
              this.$emit('success')
            } else if (status === 'cancelled') {
              if (!this.hasTimeout) {
                this.hasTimeout = true
                this.createModal({
                  title: 'Something went wrong',
                  message: 'Transaction has timed-out or was cancelled, We\'re redirecting back to your Order Summary.',
                  btnMessage: 'Proceed',
                  callback: () => {
                    this.$emit('failed')
                  }
                })
              }
            } else {
              setTimeout(this.commencePolling, 500)
            }
          },
          (error) => {
            if (!error.response || error.response.status === 0) {
              this.commencePolling()
            } else {
              this.createModal({
                title: 'Something went wrong',
                message: 'Transaction has timed-out or was cancelled, We\'re redirecting back to your Order Summary.',
                btnMessage: 'Proceed',
                callback: () => {
                  this.$emit('failed')
                }
              })
            }
          }
        )
    },

    getAssets (img) {
      if (!img) return
      if (img.substring(0, 4) === 'http') return img
      return require('@/assets/img/' + img)
    }
  }
}
</script>

<style scoped>
.loader {
  border-top-color: #16bdca;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
